import type { OverlayManagerState } from './types';

export type OverlayRect = {
  left: number;
  width: number;
  right: number;
  top: number;
  bottom: number;
  height: number;
};

export const indexNames = Object.freeze({
  popOutAudioPlayer: 'popOutAudioPlayer',
  popOutVideoPlayer: 'popOutVideoPlayer',
  eapArticleNextUp: 'eapArticleNextUp',
  sunriseModuleControls: 'sunriseModuleControls',
  footer: 'footer',
  actionBanner: 'actionBanner',
});

export type IndexName = (typeof indexNames)[keyof typeof indexNames];

export const stackingOrder: Partial<Record<IndexName, number>> = {
  [indexNames.footer]: 5,
  [indexNames.popOutAudioPlayer]: 10,
  [indexNames.actionBanner]: 15,
  [indexNames.eapArticleNextUp]: 20,
  [indexNames.sunriseModuleControls]: 30,
  [indexNames.popOutVideoPlayer]: 40,
};

export const defaultOverlayState: OverlayManagerState = {
  overlays: [],
};
